import { Component, Input } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-view-course-details',
  templateUrl: './view-course-details.component.html',
  styleUrls: ['./view-course-details.component.scss']
})
export class ViewCourseDetailsComponent {
  //course data 
  @Input() data: string | any;

   // file urls 
   apilink = GlobalConstants.apiURL;
   GlobalConstants = GlobalConstants;
   staticURL = GlobalConstants.staticFilesURL;

}
